// Copyright © 2021 Move Closer
import { TeaserBoxVersion } from './TeaserBox.contracts';
import { ModuleDriver } from '../_contracts';
import { AdBannerModuleUi } from '../AdBanner/AdBanner.ui';
import { GradientDomain } from '../Tile/Tile.contracts';
/**
 * List of TeaserBox versions which doesn't support/display ReadMore link
 */
export const versionWithoutReadMore = [
    TeaserBoxVersion['1XL'],
    TeaserBoxVersion['2L'],
    TeaserBoxVersion['8S'],
    TeaserBoxVersion['8T'],
    TeaserBoxVersion['L-4S'],
    TeaserBoxVersion['L-8S']
];
export const addonsRegistry = {
    [ModuleDriver.AdBanner]: AdBannerModuleUi
};
/**
 * Domain display names mapping for gradient colors
 */
export const domainDisplayNames = {
    [GradientDomain.Defence24PL]: 'Defence24.pl',
    [GradientDomain.Energetyka24COM]: 'Energetyka24.com',
    [GradientDomain.CyberDefence24PL]: 'CyberDefence24.pl',
    [GradientDomain.Space24PL]: 'Space24.pl',
    [GradientDomain.Defence24COM]: 'Defence24.com',
    [GradientDomain.InfoSecurity24PL]: 'InfoSecurity24.pl',
    [GradientDomain.Defence24MSPO]: 'Defence24 MSPO',
    [GradientDomain.Defence24TV]: 'Defence24.tv'
};
